import React, { Component } from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { Button } from '@mui/material';
import ScheduleSendOutlinedIcon from '@mui/icons-material/ScheduleSendOutlined';
import CustomizedSnackbars from '../material-snackbars';
import ScheduleReportDialog from './schedule-report-dialog';

// Botão "Agendar envio" plugável em QUALQUER tela de relatório.
// Integração na tela (≈ 3 linhas):
//   1) no método que filtra, guarde a URL do paginate: this.setState({ scheduleRequest: url })
//   2) renderize: {this.state.showGrid && <ScheduleReportButton reportKey="calleds" request={this.state.scheduleRequest} />}
// reportKey = chave do catálogo (REPORT_SCHEDULE_CATALOG em services/report-schedule.service.js).
class ScheduleReportButton extends Component {
  constructor(props) {
    super(props);
    this.state = { open: false, dialogKey: 0, notification: { open: false, variant: 'success', message: '' } };
  }

  get currentUser() {
    const u = (this.props.userSession && this.props.userSession.user) || {};
    return { id: u.id, name: u.name, email: u.email };
  }

  // Remonta o dialog a cada abertura → sempre captura o filtro MAIS RECENTE da tela.
  open = () => this.setState(p => ({ open: true, dialogKey: p.dialogKey + 1 }));
  close = () => this.setState({ open: false });

  saved = (schedule) => {
    const { intl } = this.props;
    this.setState({
      open: false,
      notification: { open: true, variant: 'success', message: intl.formatMessage({ id: 'report.schedule.toast.created' }, { name: schedule.name }) },
    });
  };

  render() {
    const { intl, reportKey, request, fullWidth = true, color = 'secondary' } = this.props;
    const { open, dialogKey, notification } = this.state;
    return (
      <>
        <Button fullWidth={fullWidth} variant="contained" color={color} onClick={this.open} disabled={!request}
          startIcon={<ScheduleSendOutlinedIcon />}>
          {intl.formatMessage({ id: 'report.schedule.button' })}
        </Button>
        {open && (
          <ScheduleReportDialog key={dialogKey} open={open} onClose={this.close} onSaved={this.saved}
            reportKey={reportKey} request={request} currentUser={this.currentUser} />
        )}
        <CustomizedSnackbars variant={notification.variant} message={notification.message} isOpen={notification.open}
          toClose={() => this.setState({ notification: { ...notification, open: false } })} />
      </>
    );
  }
}

const mapStateToProps = state => ({ userSession: state.userSession });

export default injectIntl(connect(mapStateToProps)(ScheduleReportButton));
